export const setCookie = async (
  name: string,
  value: string,
  path = '/',
  domain = '.socialcurator.com'
) => {
  const chosenDomain = process.env.NODE_ENV === 'development' ? 'localhost' : domain
  const expires = new Date(2038, 1, 1).toString()
  document.cookie = `${name}=${value};path=${path};domain=${chosenDomain};expires=${expires};SameSite=None;Secure;`
}
